/**
 * Legge il body di una risposta API.
 * Se PHP ha messo un warning prima del JSON, axios lascia una stringa:
 * il form resterebbe compilato anche se il salvataggio è riuscito.
 */
export function parseApiBody(data) {
  if (data && typeof data === 'object') {
    return data;
  }

  if (typeof data !== 'string') {
    return null;
  }

  const trimmed = data.trim();
  if (!trimmed) {
    return null;
  }

  try {
    const parsed = JSON.parse(trimmed);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    const start = trimmed.indexOf('{');
    const end = trimmed.lastIndexOf('}');
    if (start === -1 || end <= start) {
      return null;
    }
    try {
      const parsed = JSON.parse(trimmed.slice(start, end + 1));
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
      return null;
    }
  }
}

export function isApiSuccess(data) {
  const body = parseApiBody(data);
  if (!body) {
    return false;
  }
  return body.success === true || body.success === 1 || body.success === 'true';
}

export function apiErrorMessage(data, fallback) {
  const body = parseApiBody(data);
  if (!body) {
    return fallback;
  }
  return body.message || body.error || fallback;
}
